import { Pipe, PipeTransform } from '@angular/core';
import { UserInfoService } from '../services/user-info.service';

@Pipe({
  name: 'timeFromNow',
  standalone: true
})
export class TimeFromNowPipe implements PipeTransform {
  constructor(private userInfoService: UserInfoService) {}

  transform(date: Date | null, ...args: unknown[]): string {
    if (!date) {
      return '';
    }

    const userLanguage = this.userInfoService.info$.value.language || 'en';
    const formatter = new Intl.RelativeTimeFormat(userLanguage);
    const ranges: any = {
      years: 3600 * 24 * 365,
      months: 3600 * 24 * 30,
      weeks: 3600 * 24 * 7,
      days: 3600 * 24,
      hours: 3600,
      minutes: 60,
      seconds: 1
    };

    const secondsElapsed = Math.max(date.getTime() - Date.now()) / 1000;
    if (secondsElapsed < 61 && secondsElapsed > -61) {
      return $localize`Just now`;
    }

    for (const key in ranges) {
      if (ranges[key] < Math.abs(secondsElapsed)) {
        const delta = secondsElapsed / ranges[key];

        return formatter.format(
          Math.round(delta),
          key as Intl.RelativeTimeFormatUnit
        );
      }
    }

    return '';
  }
}
